<template>
  <div class="error auto_1280">
    <div class="text">404</div>
  </div>
</template>
<script>
export default {
  name: '404',
  mounted () {
    setTimeout(() => {
      this.$router.push({
        name: 'Home',
        query: {
          columnd: 38
        }
      })
    }, 2000)
  }
}
</script>
<style scoped>
.error{padding: 5% 0; color: #e4007f; font-size: 300px; font-family: 'Cinzel-Bold'; text-align: center;}
</style>
